module.exports = __webpack_public_path__ + "img/spider.40333a9d.png";